import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class CryptoService {
  
  private readonly key = 'b@ch0c0-3b1ll1a-s3cur1ty-k3y-2026!';
  private keyBytes: any;
  private ivBytes: any;
  private desfase: number = 0;

  constructor() {
    const keyHash = CryptoJS.SHA256(this.key);
    this.keyBytes = CryptoJS.lib.WordArray.create(keyHash.words.slice(0, 8), 32);
    const ivHash = CryptoJS.SHA256(this.key);
    this.ivBytes = CryptoJS.lib.WordArray.create(ivHash.words.slice(0, 8), 16);
  }

  encrypt(plainText: string): string {
    const encrypted = CryptoJS.AES.encrypt(plainText, this.keyBytes, {
      iv: this.ivBytes,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return encrypted.toString(); // Base 64
  }

  setServerTime(serverTime: number): void {
    this.desfase = serverTime - Date.now();
  }

  getServerTime(): number {
    return this.desfase;
  }
  
  getTimestamp(): string {
    return (Date.now() + this.desfase).toString();
  }

  encryptTimestamp(): string {
    return this.encrypt(this.getTimestamp());
  }

}


// WEBPACK FOOTER //
// ./src/app/security/crypto.service.ts